function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Card, Form, Table } from 'react-bootstrap';
import { ClaimFinancialField } from './ClaimFinancialField';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
export default function ClaimFieldsTable(_ref) {
  let {
    calculations,
    claim,
    setClaim,
    title,
    rows,
    refreshCalculations
  } = _ref;
  const filteredRows = rows.filter(row => row.shouldDisplay === undefined || !!row.shouldDisplay);
  const renderFieldValue = (row, fieldAttribute) => {
    const fieldName = row[fieldAttribute].name;
    if (calculations[fieldName]) {
      const fieldValue = calculations[fieldName];
      const formattedValue = typeof fieldValue === 'number' ? Number(fieldValue).toFixed(2) : typeof fieldValue === 'string' && !isNaN(fieldValue) ? Number(fieldValue).toFixed(2) : fieldValue;
      const inputType = parseFloat(fieldValue) ? 'number' : 'text';
      const AsComponents = {
        text: Form.Control,
        number: FormattedNumberInput
      };
      const AsComponent = AsComponents[inputType];
      return /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
        as: AsComponent,
        object: _objectSpread(_objectSpread({}, calculations), {}, {
          claim: _objectSpread({}, calculations)
        }),
        disabled: true,
        name: fieldName,
        type: "text",
        size: "sm",
        "data-testid": "benefit-calculations-".concat(fieldName),
        style: {
          textAlign: 'right'
        },
        value: formattedValue
      });
    } else if (fieldName === null) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    const isEditable = row[fieldAttribute].editable;
    return /*#__PURE__*/React.createElement(ClaimFinancialField, {
      size: "sm",
      claim: claim,
      setClaim: setClaim,
      fieldName: fieldName,
      disabled: !isEditable,
      style: {
        width: '176px',
        textAlign: 'right'
      },
      onClaimUpdateSuccess: refreshCalculations
    });
  };
  const tableContainsRowWith2CostFields = rows.some(row => 'field_2' in row);
  const tableContainsRowWithSingleCostField = rows.some(row => 'field' in row);
  const rowsWithSingleFieldShouldHaveWiderText = tableContainsRowWith2CostFields && tableContainsRowWithSingleCostField;
  const singleCostFieldRowLeftColSpan = rowsWithSingleFieldShouldHaveWiderText ? 2 : 1;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-secondary text-primary"
  }, title), /*#__PURE__*/React.createElement(Table, {
    striped: true
  }, /*#__PURE__*/React.createElement("tbody", null, filteredRows.map((row, index) => /*#__PURE__*/React.createElement("tr", {
    key: index
  }, /*#__PURE__*/React.createElement("td", {
    className: "".concat(row.className || ''),
    colSpan: 'field' in row ? singleCostFieldRowLeftColSpan : 1
  }, row.text || row.render()), 'field_1' in row && /*#__PURE__*/React.createElement("td", {
    style: {
      width: '200px'
    },
    className: "text-right"
  }, renderFieldValue(row, 'field_1'), " "), 'field_2' in row && /*#__PURE__*/React.createElement("td", {
    style: {
      width: '200px'
    },
    className: "text-right"
  }, renderFieldValue(row, 'field_2'), " "), 'field' in row && /*#__PURE__*/React.createElement("td", {
    style: {
      width: '200px'
    },
    className: "text-right"
  }, renderFieldValue(row, 'field'), " ")))))));
}